editImageCarrouselElementController.$inject = [
                                         '$scope', 
                                         '$translate',
                                         '$mdDialog', 
                                         'MediasFactory', 
                                         'AlertingFactory', 
                                         'elementData',
                                         'elementView',
                                         'context'];
export function editImageCarrouselElementController(
                                              $scope, 
                                              $translate,
                                              $mdDialog,
                                              MediasFactory, 
                                              AlertingFactory, 
                                              elementData, 
                                              elementView,
                                              context) {
  $scope.ok = submit;
  $scope.cancel = cancel;
  $scope.deleteItem = deleteItem;
  $scope.removePicture = removePicture;

  init();

  function init() {
    $scope.elementData = elementData;
    $scope.elementView = elementView;
    $scope.site = context.site;
    $scope.companyId = context.companyId;

    $scope.fileNames = {};

    $scope.loading = false;
    $scope.pictureFile = null;
    $scope.mediaUrl = '';


    updateMediaUrls();
    $scope.$watch('fileNames.picture', function(newFile) {
      if (newFile) {
        uploadImage(newFile);
      }
    });
  }

  function submit() {
    $mdDialog.hide({ type: 'ok', data: $scope.elementData });
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function deleteItem() {
    $mdDialog.hide({type: 'delete'});
  }

  function removePicture() {
    delete $scope.elementData.pictureId;
    updateMediaUrls();
  }

  function updateMediaUrls() {
    if (typeof elementData.pictureId === 'number') {
      $scope.mediaUrl = MediasFactory.pictureUrl($scope.companyId, elementData.pictureId);
    } else {
      $scope.mediaUrl = '';
    }
  }

  function uploadImage(file) {
    $scope.loading = true;
    MediasFactory.upload2($scope.companyId, $scope.site.id, 'image', file, 
                          response => {
                            elementData.pictureId = response.data.media_id;
                            $scope.loading = false;
                            updateMediaUrls();
                          },
                          response => {
                            $scope.loading = false;
                            AlertingFactory.error(response.data.error);
                          });
  }

}
